import {
  ProductOfferingBenefit,
  ProductOfferingPlatform,
  ProductPlatformGroup,
  ProductPlatformOther,
} from './product-offering-feature.model';
import { ProductCode } from './product.model';

export type Features = ProductOfferingBenefit | ProductOfferingPlatform;

export type ProductFeatures = { productCode: ProductCode; features: Features[] };

export const PRODUCT_FEATURES: ProductFeatures[] = [
  {
    productCode: ProductCode.JS24FREE,
    features: [
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineATS,
      ProductOfferingBenefit.Calendar10Days,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  }, // free, visible on UI
  {
    productCode: ProductCode.JS24SOLO,
    features: [
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineATS,
      ProductOfferingBenefit.InboxIn,
      ProductOfferingBenefit.GoogleJobPosting,
      ProductOfferingBenefit.Calendar,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JS24BASIC,
    features: [
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineATS,
      ProductOfferingBenefit.InboxIn,
      ProductOfferingBenefit.GoogleJobPosting,
      ProductOfferingBenefit.Calendar,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JOBSSTARTER,
    features: [
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineATS,
      ProductOfferingBenefit.InboxIn,
      ProductOfferingBenefit.GoogleJobPosting,
      ProductOfferingBenefit.Calendar,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  }, // visible on UI
  {
    productCode: ProductCode.JS24PLUS,
    features: [
      ProductOfferingBenefit.OnlineATS,
      ProductOfferingBenefit.InboxIn,
      ProductOfferingBenefit.GoogleJobPosting,
      ProductPlatformGroup.Jobs,
      ProductPlatformGroup.JobScout24,
      ProductPlatformOther.JobWinner,
      ProductOfferingBenefit.Calendar,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  }, // visible on UI
  {
    productCode: ProductCode.JS24ADVANCED,
    features: [
      ProductOfferingBenefit.OnlineATS,
      ProductOfferingBenefit.InboxIn,
      ProductOfferingBenefit.GoogleJobPosting,
      ProductPlatformGroup.Jobs,
      ProductPlatformGroup.JobScout24,
      ProductPlatformOther.JobWinner,
      ProductOfferingBenefit.Calendar,
    ],
  }, // visible on UI
  {
    productCode: ProductCode.JOBSOFFER22FREE,
    features: [
      ProductPlatformGroup.Jobs,
      ProductOfferingBenefit.Calendar10Days,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  }, // free, visible on UI
  {
    productCode: ProductCode.JOBSOFFER22XS,
    features: [
      ProductPlatformGroup.Jobs,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.Calendar7,
      ProductOfferingBenefit.JobAlert1x,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  }, // paid, visible on UI
  {
    productCode: ProductCode.JOBSOFFER22S,
    features: [
      ProductPlatformGroup.Jobs,
      ProductOfferingBenefit.OnlineCampaignsCheckmark,
      ProductOfferingBenefit.Calendar,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert1x,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  }, // paid, visible on UI
  {
    productCode: ProductCode.JOBSOFFER22M,
    features: [
      ProductPlatformGroup.Jobs,
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineCampaignsCheckmark,
      ProductOfferingBenefit.Calendar,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert3x,
      ProductOfferingBenefit.JobBoost2x,
      ProductOfferingBenefit.PartnerNetworkCheckmark,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  }, // paid, visible on UI
  {
    productCode: ProductCode.JOBSOFFER22L,
    features: [
      ProductPlatformGroup.Jobs,
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineCampaignsBoost,
      ProductOfferingBenefit.Calendar45,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert5x,
      ProductOfferingBenefit.JobBoost4x,
      ProductOfferingBenefit.PartnerNetworkBoost,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  }, // paid, visible on UI
  {
    productCode: ProductCode.JOBSOFFER22XL,
    features: [
      ProductPlatformGroup.Jobs,
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineCampaignsPlus,
      ProductOfferingBenefit.Calendar60,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert11x,
      ProductOfferingBenefit.JobBoost10x,
      ProductOfferingBenefit.PartnerNetworkPlus,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  }, // paid, visible on UI

  {
    productCode: ProductCode.JOBUP24FREE,
    features: [
      ProductPlatformGroup.JobUp,
      ProductOfferingBenefit.Calendar10Days,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JOBUP24LITE,
    features: [
      ProductPlatformGroup.JobUp,
      ProductOfferingBenefit.Calendar7,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert1x,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JOBUP24BASIC,
    features: [
      ProductPlatformGroup.JobUp,
      ProductOfferingBenefit.OnlineCampaigns,
      ProductOfferingBenefit.Calendar30,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert1x,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JOBUP24ADVANCED,
    features: [
      ProductPlatformGroup.JobUp,
      ProductPlatformGroup.Jobs,
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineCampaigns,
      ProductOfferingBenefit.Calendar30,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert3x,
      ProductOfferingBenefit.JobBoost2x,
      ProductOfferingBenefit.PartnerNetwork,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JOBUP24ULTIMATE,
    features: [
      ProductPlatformGroup.JobUp,
      ProductPlatformGroup.Jobs,
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineCampaignsBoost,
      ProductOfferingBenefit.Calendar45,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert5x,
      ProductOfferingBenefit.JobBoost4x,
      ProductOfferingBenefit.PartnerNetworkBoost,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JOBUP24ULTIMATEPLUS,
    features: [
      ProductPlatformGroup.JobUp,
      ProductPlatformGroup.Jobs,
      ProductPlatformGroup.JobScout24,
      ProductOfferingBenefit.OnlineCampaignsPlus,
      ProductOfferingBenefit.Calendar60,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert9x, // new - added to ProductOfferingBenefit
      ProductOfferingBenefit.JobBoost8x, // new - added to ProductOfferingBenefit
      ProductOfferingBenefit.PartnerNetworkPlus,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JOBUPAPPRENTICESHIP,
    features: [
      ProductPlatformGroup.JobUp,
      ProductOfferingBenefit.OnlineCampaigns,
      ProductOfferingBenefit.Calendar90,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert1x,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JOBSAPPRENTICESHIP,
    features: [
      ProductPlatformGroup.Jobs,
      ProductOfferingBenefit.OnlineCampaigns,
      ProductOfferingBenefit.Calendar90,
      ProductOfferingBenefit.Performance,
      ProductOfferingBenefit.JobAlert1x,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.JOBSFLEX,
    features: [ProductPlatformGroup.Jobs, ProductOfferingBenefit.Calendar],
  },
  {
    productCode: ProductCode.JOBSOFFSITE,
    features: [ProductPlatformGroup.Jobs, ProductOfferingBenefit.Calendar30],
  },
  {
    productCode: ProductCode.JOBUPOFFSITE,
    features: [ProductPlatformGroup.JobUp, ProductOfferingBenefit.Calendar30],
  },
  {
    productCode: ProductCode.JOBSSPONTANEOUSAPPLICATION,
    features: [ProductPlatformGroup.Jobs, ProductOfferingBenefit.Calendar365],
  },
  {
    productCode: ProductCode.JOBUPSPONTANEOUSAPPLICATION,
    features: [ProductPlatformGroup.JobUp, ProductOfferingBenefit.Calendar365],
  },
  {
    productCode: ProductCode.VBPPAID,
    features: [
      ProductPlatformGroup.Jobs,
      ProductOfferingBenefit.Calendar60,
      ProductOfferingBenefit.OnlineCampaigns,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
  {
    productCode: ProductCode.VBPFREE,
    features: [
      ProductPlatformGroup.Jobs,
      ProductOfferingBenefit.Calendar10Days,
      ProductOfferingBenefit.OnlineCampaigns,
      ProductOfferingBenefit.SwissCustomerSupportCheckmark,
    ],
  },
];
